var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEmployee = function SvgEmployee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5zm0 2c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3zm0 9c-5.512 0-10 4.488-10 10v9.676l3.52 1.406L19.25 48h11.5l.73-13.918L35 32.676V23c0-5.512-4.488-10-10-10zm-1 2.066V16h2v-.934c3.953.493 7 3.844 7 7.934v8.324l-3.45 1.38L28.853 46h-7.704l-.699-13.297L17 31.324V23a7.984 7.984 0 017-7.934zM24 17v10h2V17z"
  })));
};

export default SvgEmployee;